<template>
  <div>
    <navigation/>
    <toolbar></toolbar>
    <v-content>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Navigation from '@/modules/ui/_components/Navigation';
import Toolbar from '../../modules/ui/_components/Toolbar';

export default {
  name: 'Layout',
  components: { Toolbar, Navigation },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions({
      storeSignOut: 'auth/signOut',
      loadUser: 'auth/loadUser',
    }),
    signOut() {
      this.storeSignOut().then(() => {
        this.$router.push({ name: 'SignIn' });
      });
    },
  },
  created() {
    this.loadUser();
  },
};
</script>

<style scoped>

</style>
